<template>
  <v-container fluid>
    <NonConformitiesTable class="pb-4">
      <template v-slot:actions="{ dataset }">
        <avs-exportButton
          :data="dataset"
          :prepare="preFmtData"
          :name="$t('actions.export_')"
          :spantext="$t('actions.export', { entity: $tc('categories.nonconformity.name', 2) })"
        />
        <avs-createButton
          :to="{ name: 'NonConformityCreateUpdate' }"
          :spantext="
            $t('actions.create', {
              entity: $tc('categories.nonconformity.name', 1).toLowerCase()
            })
          "
          :name="
            $t('actions.new_female', {
              entity: $tc('categories.nonconformity.name', 1).toLowerCase()
            })
          "
        />
      </template>
    </NonConformitiesTable>
  </v-container>
</template>
<script>
import { NonConformitiesTable } from "@/components"
import { fmtNonConformityData } from "@/utils/download"

export default {
  name: "NonConformitiesView",
  components: { NonConformitiesTable },
  methods: {
    preFmtData(dataset) {
      return fmtNonConformityData(dataset)
    }
  }
}
</script>
